<template>
    <v-layout align-center justify-center row wrap>
        <v-flex xs12 sm12 md12 lg9 xl8 class="pa-2">
            <p v-if="!connected_account_is_temp">
                <b>Številka Tuš klub kartice: {{ card_number }}</b>
            </p>
            <p class="foreword" v-if="!connected_account_is_temp">
                Tuš klub profil vam omogoča pregled in posodobitev osebnih podatkov, ki ste jih vnesli ob včlanitvi v Tuš klub, in enostavno upravljanje s privolitvami za obdelavo osebnih podatkov ter načine obveščanja. Prikazuje vaše aktivne kartice, s katerimi lahko koristite ugodnosti. Preverite lahko aktivacije podklubov na kartici (npr. senior, študent/dijak, …). Svoje predloge za izboljšave nam lahko sporočite na e-naslov <a href="mailto:tus.klub@tus.si">tus.klub@tus.si</a> ali na brezplačno telefonsko številko 080 13 10. Veseli jih bomo.
            </p>
            <empty-space />
            <div class="user-info" v-if="!silentLoading">
                <p>
                    <label>Ime</label>
                    {{ name }}
                </p>
                <template v-if="!connected_account_is_temp">
                    <p>
                        <label>Priimek</label>
                        {{ lastname }}
                    </p>
                    <p>
                        <label>Elektronski naslov</label>
                        {{ email }}
                    </p>
                    <p>
                        <label>Mobilna številka</label>
                        {{ mobileNo }}
                    </p>
                </template>
                <template v-if="connected_account_is_temp">
                    <p>
                        <label>Elektronski naslov</label>
                        {{ email }}
                    </p>
                    <empty-space height="50px" />
                    <div class="foreword">
                        Trenutno je vaš profil brez Tuš klub kartice. Povežite obstoječo kartico ali se včlanite in koristite izjemne Tuš klub ugodnosti: dobroimetje na kartici D*NAR, popusti, nagrade, takojšen prihranek, zvezdice zvestobe, Mojih 10...
                    </div>
                    <empty-space />
                    <v-btn depressed @click="joinClub()" color="primary_action_small">Včlani se v Tuš klub</v-btn> <v-btn depressed @click="connectCard()" color="primary_action_small">Poveži kartico</v-btn>
                </template>
            </div>
            <div class="loader" v-if="silentLoading">
                <empty-space />
                <v-progress-circular :indeterminate="true" size="50" ></v-progress-circular>
            </div>
        </v-flex>
    </v-layout>
</template>

<script>
    import EmptySpace from "../EmptySpace";
    import utils from "../../store/utils";

    export default {
        name: "ProfileTab",
        components: {EmptySpace},
        computed: {
            connected_account_is_temp: utils.vuexBuildSetGet(this, 'profile', 'user.connected_account_is_temp'),
            card_number: utils.vuexBuildSetGet(this, 'profile', 'user.card'),
            name: utils.vuexBuildSetGet(this, 'profile', 'user.personal.name'),
            lastname: utils.vuexBuildSetGet(this, 'profile', 'user.personal.surname'),
            email: utils.vuexBuildSetGet(this, 'profile', 'user.personal.eMail'),
            mobileNo: utils.vuexBuildSetGet(this, 'profile', 'user.personal.mobileNo'),
            silentLoading: utils.vuexBuildSetGet(this, 'profile', 'silentLoading'),
        },
        methods: {
            joinClub(){
                this.$router.push('/ustvari/vclanitev/korak1');
            },
            connectCard(){
                this.$router.push('/racun/povezi');
            }
        }
    }
</script>

<style scoped>
    @import "../../styles/variables.less";

    .loader {
        text-align: center;
    }

    .foreword {
        font-style: italic;
    }

    .user-info p{
        padding: 5px;
        margin-bottom: 0px;
        font-weight: bold;
        border-top: 1px solid #c1c1c1;
    }

    .user-info p:last-child{
        border-bottom: 1px solid #c1c1c1;
    }
    .user-info label{
        font-weight: normal;
        width: 250px;
        display: inline-block;
    }

</style>